import styled from 'styled-components';

export const Link = styled.a`
  text-decoration: none;
  display: flex;
  &:hover {
    color: #0065ff;
    text-decoration: underline;
  }
  &:active {
    color: #0049b0;
  }
  color: #5592c5;
  fontSize: 0.8rem;
  fontWeight: 300;
  textAlign: center;
`;

export const InternalLink = styled.div`
  text-decoration: none;
  cursor: pointer;
  display: flex;
  &:hover {
    color: #0065ff;
    text-decoration: underline;
  }
  &:active {
    color: #0049b0;
  }
  color: #5592c5;
  fontSize: 0.8rem;
  fontWeight: 300;
  textAlign: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  position: relative;
  height: 50px;
`;

export const Close = styled.span`
  position: absolute;
  right: 0px;
  top: 4px;
  padding: 5px;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;

export const MonitorImage = styled.img`
  max-width: 250px;
`;

export const TextBlock = styled.div`
  padding: 0 20px;
  &>h2 {
    margin: 0;
    text-align: center;
  }
`;

export const HorizontalLine = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, .1);
  width: 100%;
  margin: 20px 0px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 0 30px 0;
`;

export const DownloadIcon = styled.img`
  height: 18px;
  margin-right: 5px;
`;

export const LinksBlock = styled.div`
  margin-top: 15px;
  font-size: .8em;
  display: flex;
  justify-content: space-between;
`;
